<template>
  <div class="mt-12 mb-2">
    <span class="d-flex align-items-center">
      <h5
        role="button"
        @click="isInlandsfluegeCollapsed = !isInlandsfluegeCollapsed"
        :aria-expanded="isInlandsfluegeCollapsed ? 'true' : 'false'"
        aria-controls="collapse-3"
        class="user-select-none mb-0"
      >
        <b-icon
          v-if="!isInlandsfluegeCollapsed"
          :scale="0.75"
          icon="chevron-right"
          aria-hidden="true"
        ></b-icon>
        <b-icon v-else :scale="0.75" icon="chevron-down" aria-hidden="true"></b-icon>
        Inlandsflüge
      </h5>
      <b-button
        v-if="!localInlandsflugExists"
        variant="outline-primary"
        size="sm"
        class="hinzufuegen-btn ml-3"
        @click="onAdd"
      >
        <Plus :size="16" />
        Inlandsflug hinzufügen
      </b-button>
    </span>
    <hr class="w- ml-0" />
    <b-collapse
      id="collapse-3"
      :class="isInlandsfluegeCollapsed ? null : 'collapsed'"
      v-model="isInlandsfluegeCollapsed"
    >
      <div v-if="inlandsfluege?.length > 0">
        <div v-for="(inlandsflug, i) in inlandsfluege" :key="inlandsflug.id" class="mb-6">
          <h6 class="mb-4 ml-2">
            {{ i + 1 + '. Inlandsflug' }}
            <i
              v-if="inlandsflug.matchingSeasonInlandsflug === null"
              class="fas fa-asterisk text-warning icon-sm"
              style="align-self: start; position: absolute; font-size: 0.8rem"
              v-b-tooltip.hover
              title="Kein passender Saison-Inlandsflug gefunden."
            ></i>
            <span class="ml-4" @click="$emit('delete', inlandsflug.id)" style="cursor: pointer">
              <i class="fas fa-trash" style="color: black"></i>
            </span>
          </h6>
          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">Tag / Verkehrstag / Datum</h6>
            </b-list-group-item>
            <b-list-group-item
              class="col-6 p-2 pl-4"
              style="display: grid; grid-template-columns: repeat(3, 1fr)"
            >
              <b-form-input
                v-model="inlandsflug.tag"
                :disabled="!inlandsflug?.isOnlyLocal"
                class="border-0 pl-3 m-0 leftLabel"
                type="number"
                step="1"
                min="0.00"
                max="1000.00"
                :number="true"
                placeholder="-"
              ></b-form-input>
              <div class="leftLabel p-2">
                {{ getVerkehrstagOfInlandsflug(activeReisetermin, inlandsflug) }}
              </div>
              <div class="leftLabel p-2">
                {{ getDateOfIlandsflug(activeReisetermin, inlandsflug) }}
              </div>
            </b-list-group-item>
          </b-list-group>
          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">
                Einkauf
                <i
                  v-if="
                    inlandsflug.matchingSeasonInlandsflug?.einkauf !==
                      inlandsflug.valuesBeforeEdit?.einkauf &&
                    !inlandsflug?.isOnlyLocal &&
                    inlandsflug.matchingSeasonInlandsflug !== null
                  "
                  class="fas fa-asterisk text-warning icon-sm"
                  style="align-self: start; position: absolute"
                  v-b-tooltip.hover
                  :title="`Saisonwert: ${inlandsflug.matchingSeasonInlandsflug?.einkauf.toUpperCase()}`"
                ></i>
              </h6>
            </b-list-group-item>
            <b-list-group-item class="col-6 d-flex align-items-center">
              <AppSelect
                v-model="inlandsflug.einkauf"
                :options="einkaufOptions"
                label="Einkauf"
                placeholder="-"
                hide-search
                clearable
                class="einkauf-select"
              />
            </b-list-group-item>
          </b-list-group>
          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">Abflughafen</h6>
            </b-list-group-item>
            <b-list-group-item class="col-6 d-flex align-items-center">
              <AirportsSucheMultiselect
                class="w-100"
                :disabled="!inlandsflug?.isOnlyLocal"
                isSidebarTerminplanung
                v-model="inlandsflug.abflughafenIataCode"
                :isMultipleAllowed="true"
                :openDirection="'top'"
                :filterCountry="activeReisetermin?.reiseterminkuerzel?.substring(0, 2)"
                id="abflughafen"
                height="32px"
              ></AirportsSucheMultiselect>
            </b-list-group-item>
          </b-list-group>
          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">
                Zielflughafen
                <i
                  v-if="
                    inlandsflug.matchingSeasonInlandsflug?.zielflughafenIataCode !==
                      inlandsflug.valuesBeforeEdit?.zielflughafenIataCode &&
                    !inlandsflug?.isOnlyLocal &&
                    inlandsflug.matchingSeasonInlandsflug !== null
                  "
                  class="fas fa-asterisk text-warning icon-sm"
                  style="align-self: start; position: absolute"
                  v-b-tooltip.hover
                  :title="`Saisonwert: ${inlandsflug.matchingSeasonInlandsflug?.zielflughafenIataCode}`"
                ></i>
              </h6>
            </b-list-group-item>
            <b-list-group-item class="col-6 d-flex align-items-center">
              <AirportsSucheMultiselect
                class="w-100"
                isSidebarTerminplanung
                v-model="inlandsflug.zielflughafenIataCode"
                :isMultipleAllowed="false"
                :openDirection="'top'"
                :filterCountry="activeReisetermin?.reiseterminkuerzel?.substring(0, 2)"
                id="abflughafen"
                height="32px"
              ></AirportsSucheMultiselect>
            </b-list-group-item>
          </b-list-group>
          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">
                Frühester Abflug
                <i
                  v-if="
                    inlandsflug.matchingSeasonInlandsflug?.fruehesterAbflug?.substring(0, 5) !==
                      inlandsflug.valuesBeforeEdit?.fruehesterAbflug?.substring(0, 5) &&
                    !inlandsflug?.isOnlyLocal &&
                    inlandsflug.matchingSeasonInlandsflug !== null
                  "
                  class="fas fa-asterisk text-warning icon-sm"
                  style="align-self: start; position: absolute"
                  v-b-tooltip.hover
                  :title="`Saisonwert: ${inlandsflug.matchingSeasonInlandsflug?.fruehesterAbflug?.substring(
                    0,
                    5
                  )}`"
                ></i>
              </h6>
            </b-list-group-item>
            <b-list-group-item class="col-6 d-flex align-items-center">
              <date-picker
                class="w-100"
                v-model="inlandsflug.fruehesterAbflug"
                type="time"
                input-class="form-control"
                format="HH:mm"
                value-type="format"
                ref="datepicker"
                :append-to-body="false"
              ></date-picker>
            </b-list-group-item>
          </b-list-group>
          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">
                Späteste Ankunft
                <i
                  v-if="
                    inlandsflug.matchingSeasonInlandsflug?.spaetesteAnkunft?.substring(0, 5) !==
                      inlandsflug.valuesBeforeEdit?.spaetesteAnkunft?.substring(0, 5) &&
                    !inlandsflug?.isOnlyLocal &&
                    inlandsflug.matchingSeasonInlandsflug !== null
                  "
                  class="fas fa-asterisk text-warning icon-sm"
                  style="align-self: start; position: absolute"
                  v-b-tooltip.hover
                  :title="`Saisonwert: ${inlandsflug.matchingSeasonInlandsflug?.spaetesteAnkunft?.substring(
                    0,
                    5
                  )}`"
                ></i>
              </h6>
            </b-list-group-item>
            <b-list-group-item class="col-6 d-flex align-items-center">
              <date-picker
                class="w-100"
                v-model="inlandsflug.spaetesteAnkunft"
                :disabled="inlandsflug.minimaleUmsteigezeit != '' && inlandsflug.minimaleUmsteigezeit != null"
                type="time"
                input-class="form-control"
                format="HH:mm"
                value-type="format"
                ref="datepicker"
                :append-to-body="false"
              ></date-picker>
            </b-list-group-item>
          </b-list-group>
          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">
                Minimale Umsteigezeit
                <i
                  v-if="
                    inlandsflug.matchingSeasonInlandsflug?.minimaleUmsteigezeit !==
                      inlandsflug.valuesBeforeEdit?.minimaleUmsteigezeit &&
                    !inlandsflug?.isOnlyLocal &&
                    inlandsflug.matchingSeasonInlandsflug !== null
                  "
                  class="fas fa-asterisk text-warning icon-sm"
                  style="align-self: start; position: absolute"
                  v-b-tooltip.hover
                  :title="`Saisonwert: ${inlandsflug.matchingSeasonInlandsflug?.minimaleUmsteigezeit}`"
                ></i>
              </h6>
            </b-list-group-item>
            <b-list-group-item class="col-6 d-flex align-items-center">
              <b-form-input
                v-model="inlandsflug.minimaleUmsteigezeit"
                :disabled="inlandsflug.spaetesteAnkunft != null"
                class="border-0 pl-3 m-0 leftLabel"
                type="number"
                step="1"
                min="0.00"
                :number="true"
                placeholder="-"
              ></b-form-input>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
      <div v-else class="inlandsflug-empty">Noch keine Inlandsflüge angelegt.</div>
    </b-collapse>
  </div>
</template>

<script>
import { Plus } from 'lucide-vue';
import DatePicker from 'vue2-datepicker';
import { format, add, getISODay } from 'date-fns';
import AirportsSucheMultiselect from '@/components/common/airports-suche-multiselect.vue';
import AppSelect from '@/components/common/app-select/app-select.vue';

export default {
  name: 'SidebarTerminplanungInlandsfluege',
  components: {
    Plus,
    DatePicker,
    AirportsSucheMultiselect,
    AppSelect,
  },
  props: {
    // kopie der Inlandsflüge
    inlandsfluege: { type: Array, default: () => [] },
    // Der aktive Reisetermin für Länderfilter sowie Verkehrstag- und Datumsberechnung
    activeReisetermin: { type: Object, default: null },
    // Steuert die Sichtbarkeit des Hinzufügen-Buttons
    localInlandsflugExists: { type: Boolean, default: false },
  },
  data() {
    return {
      isInlandsfluegeCollapsed: false,
      einkaufOptions: [
        { value: 'Skr', text: 'SKR' },
        { value: 'Dmc', text: 'DMC' },
      ],
    };
  },
  methods: {
    // Öffnet die Inlandsflug-Sektion und meldet dem Parent, dass ein lokaler Inlandsflug angelegt werden soll
    onAdd() {
      this.isInlandsfluegeCollapsed = true;
      this.$emit('add');
    },
    // Berechnet den Verkehrstag (ISO-Wochentag) eines Inlandsflugs relativ zum Abreisedatum
    getVerkehrstagOfInlandsflug(reisetermin, inlandsflug) {
      const dayOfInlandsflug = add(new Date(reisetermin.abreisedatum), { days: +inlandsflug.tag - 1 });
      return getISODay(dayOfInlandsflug);
    },
    // Berechnet das konkrete Datum eines Inlandsflugs relativ zum Abreisedatum
    getDateOfIlandsflug(reisetermin, inlandsflug) {
      const dateOfInlandsfluge = add(new Date(reisetermin.abreisedatum), { days: +inlandsflug.tag - 1 });
      return format(dateOfInlandsfluge, 'dd.MM.yyyy');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/components/_variables.bootstrap.scss';

.hinzufuegen-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.inlandsflug-empty {
  padding: 24px;
  border: 1px dashed var(--border);
  border-radius: 8px;
  text-align: center;
  font-size: $form-label-font-size;
  font-weight: $form-label-font-weight;
  color: $dark-75;
}

.detailLabelGreyedOut {
  background-color: rgba(114, 114, 114, 0.05);
  border-style: solid;
  border-color: rgba(114, 114, 114, 0.15);
}

.leftLabel {
  font-size: 1.1rem;
  font-weight: 500;
}

.list-group {
  height: 42px;
}

:deep(.form-control) {
  height: 32px !important;
}

.einkauf-select {
  --app-select-height: 32px;
}

.tooltip {
  opacity: 1 !important;
}

:deep(.mx-datepicker-content) {
  margin: 0 !important;
}
</style>
